import styled from 'styled-components';
import { WithProps, includeBaseStyle } from './base';

const Text = WithProps(styled.span`
  ${includeBaseStyle};
`);

export { Text };
